import script from "./footerZz.vue?vue&type=script&setup=true&lang=js"
export * from "./footerZz.vue?vue&type=script&setup=true&lang=js"

import "./footerZz.vue?vue&type=style&index=0&id=07ba9614&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ba9614"]])

export default __exports__